import * as Common from "@/commons/common"

export class Sheet {
  id: number
  name: string
  course_code: string
  campus_code: string
  class_code: string
  subject_code: string
  page_count: number
  sheet_type: number
  correct_image_size: number[]
  width: number
  height: number

  constructor(x: any){
    this.id = x.id;
    this.name = x.name;
    this.course_code = x.course_code;
    this.campus_code = x.campus_code;
    this.class_code = x.class_code;
    this.subject_code = x.subject_code;
    this.page_count = x.page_count;
    this.sheet_type = x.sheet_type;
    this.correct_image_size = x.correct_image_size;
    this.width = x.correct_image_size[0];
    this.height = x.correct_image_size[1];
  }
}

export class PageItem {
  page: number
  base_width: number
  base_height: number
  base64Image: string
  fieldItems: FieldItem[] = []

  constructor(page: number, sheet: any, base64Image: string, allSheetFields: any[], allFieldActivities: any[], allTensakuTexts: any[], allScoreStamps: any[], allBase64Canvases: any[], allSheetFieldMarks: any[], buffSize: number){
    this.page = page;
    this.base_width = sheet.correct_image_size[0];
    this.base_height = sheet.correct_image_size[1];
    this.base64Image = base64Image;

    allSheetFields.filter((x: any) => x.page == page).forEach((sheetField: any, idx: number) => {
      const fieldActivity: any = allFieldActivities.find((fa: any) => sheetField.id == fa.sheet_field_id);
      const tensakuTexts: any[] = allTensakuTexts.filter((tt: any) => tt.field_activity_id == fieldActivity.id);
      const scoreStamps: any[] = allScoreStamps.filter((tt: any) => tt.field_activity_id == fieldActivity.id);
      const base64Canvas: any = allBase64Canvases.find((cv: any) => fieldActivity.id == cv.field_activity_id);
      const sheetFieldMark: any = allSheetFieldMarks.find((sm: any) => sm.base_sheet_field_id == sheetField.base_sheet_field_id);
      
      const fieldITem = new FieldItem(idx, page, sheetField, fieldActivity, tensakuTexts, scoreStamps, base64Canvas, sheetFieldMark, buffSize);
      this.fieldItems.push(fieldITem);
    })
  }
}

export class FieldItem {
  idx: number
  field_activity_id: number
  sheet_activity_id: number
  sheet_field_id: number
  part1: string
  part2: string
  part3: string
  page: number
  field_name: string = ""
  x: number
  y: number
  width: number
  height: number
  scoring_type: number
  allot: number
  correct_state: number
  correct_state_cache: number
  score: number  
  score_cache: number
  saiten_completed: boolean
  saitening_teacher_id: number
  base64_canvas: string | null = null
  tensaku_texts: TensakuText[] = []
  score_stamps: ScoreStamp[] = []
  sheet_field_mark: SheetFieldMark
  is_canvas_edited: boolean = false
  is_text_stamp_edited: boolean = false
  is_score_stamp_edited: boolean = false
  tensakuTextIdx: number = 0
  scoreStampIdx: number = 0

  constructor(idx: number, page: number, sheetField: any, fieldActivity: any, tensakuTexts: any[], scoreStamps: any[], base64Canvas: any, sheetFieldMark: any, buffSize: number){
    this.idx = idx;
    this.field_activity_id = fieldActivity.id;
    this.sheet_activity_id = fieldActivity.sheet_activity_id;
    this.sheet_field_id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.page = page;
    this.x = sheetField.rim[0];
    this.y = sheetField.rim[1];
    this.width = sheetField.rim[2];
    this.height = sheetField.rim[3];
    this.scoring_type = sheetField.scoring_type;
    this.allot = sheetField.allot;
    this.correct_state = fieldActivity.correct_state;
    this.correct_state_cache = fieldActivity.correct_state;
    this.score = fieldActivity.score;
    this.score_cache = fieldActivity.score;
    this.saiten_completed = fieldActivity.saiten_completed;
    this.saitening_teacher_id = fieldActivity.saitening_teacher_id;
    this.base64_canvas = base64Canvas ? base64Canvas.src : null;
    this.sheet_field_mark = sheetFieldMark;

    this.field_name = this.part1;
    this.field_name += this.part2 ? this.part2 : "";
    this.field_name += this.part3 ? this.part3 : "";

    this.score_stamps = scoreStamps.map((x: any) => {
      const scoreStamp = new ScoreStamp();
      scoreStamp.field_activity_id = x.field_activity_id;
      scoreStamp.idx = this.scoreStampIdx++;
      scoreStamp.score = x.score;
      scoreStamp.color = x.color;
      scoreStamp.x = x.x;
      scoreStamp.y = x.y;
      scoreStamp.width = x.width;
      scoreStamp.height = x.height;
      return scoreStamp;
    });
    
    this.tensaku_texts = tensakuTexts.map((x: any) => {
      const tensakuText = new TensakuText();
      tensakuText.id = x.id;
      tensakuText.field_activity_id = x.field_activity_id;
      tensakuText.text = x.text;
      tensakuText.idx = this.tensakuTextIdx++;
      tensakuText.font_size = x.font_size;
      tensakuText.line_height = x.line_height;
      tensakuText.color = x.color;
      tensakuText.x = x.x;
      tensakuText.y = x.y;
      tensakuText.width = x.width;
      tensakuText.height = x.height;
      tensakuText.direction = x.direction;
      return tensakuText;
    });
  }
}

export interface SheetFieldMark {
  base_sheet_field_id: number
  color: string
  x: number
  y: number
  width: number
  height: number
}

export class TensakuText {
  id: number = null
  field_activity_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  direction: number = null
  base64_text: string = null
}

export class ScoreStamp {
  idx: number
  field_activity_id: number
  score: number
  x: number
  y: number
  width: number
  height: number
  color: string
}

export class ParamFieldActivity {
  id: number
  sheet_activity_id: number
  correct_state: number
  score: number
  tensaku_texts: ParamTensakuText[]
  score_stamps: ScoreStamp[]
  is_canvas_edited: boolean
  is_text_stamp_edited: boolean
  is_score_stamp_edited: boolean
  is_correct_edited: boolean

  constructor(fieldItem: FieldItem, viewedAnswerPageNos: number[]){
    this.id = fieldItem.field_activity_id;
    this.sheet_activity_id = fieldItem.sheet_activity_id;
    this.correct_state = fieldItem.correct_state;
    this.score = fieldItem.score;
    this.tensaku_texts = fieldItem.tensaku_texts;
    this.score_stamps = fieldItem.score_stamps;
    this.tensaku_texts = fieldItem.tensaku_texts.map(x => new ParamTensakuText(x));
    this.is_canvas_edited = fieldItem.is_canvas_edited;
    this.is_text_stamp_edited = fieldItem.is_text_stamp_edited;
    this.is_score_stamp_edited = fieldItem.is_score_stamp_edited;
    
    if(!fieldItem.saiten_completed && fieldItem.correct_state != null && viewedAnswerPageNos.includes(fieldItem.page)){
      // 自動採点結果が登録されているがsaiten_completedがfalseの設問はページを表示した＝確認した＝採点済みとして扱う
      this.is_correct_edited = true;
    }else{
      // その他の設問は初期表示時点から変更有無で判定
      this.is_correct_edited = fieldItem.correct_state != fieldItem.correct_state_cache || fieldItem.score != fieldItem.score_cache || fieldItem.is_score_stamp_edited;
    }
  }
}

export class ParamTensakuText {
  id: number = null
  field_activity_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  direction: number = null

  constructor(x: TensakuText){
    this.id = x.id
    this.field_activity_id = x.field_activity_id
    this.idx = x.idx
    this.text = x.text
    this.color = x.color
    this.font_size = x.font_size
    this.line_height = x.line_height
    this.x = x.x
    this.y = x.y
    this.width = x.width
    this.height = x.height
    this.direction = x.direction;
  }
}